
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bG4aH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $99c4df3eb810eb19$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $99c4df3eb810eb19$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Equipo \u2022 M\xe1s de 50 miembros",
    'fabric.elements.mentions.team.member.50plus.including.you': "Equipo \u2022 M\xe1s de 50 miembros, incluy\xe9ndote a ti",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Equipo \u2022 1 miembro} other {Equipo \u2022 {0} miembros}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Equipo \u2022 1 miembro, incluy\xe9ndote a ti} other {Equipo \u2022 {0} miembros, incluy\xe9ndote a ti}}",
    'fabric.elements.mentions.xproduct.mention.description': 'Necesita acceso a Confluence',
    'fabric.mention.error.defaultAction': 'Vuelve a intentarlo en unos segundos',
    'fabric.mention.error.defaultHeadline': 'Algo ha ido mal',
    'fabric.mention.error.differentText': 'Prueba a escribir otro texto',
    'fabric.mention.error.loginAgain': "Prueba a cerrar y abrir sesi\xf3n de nuevo",
    'fabric.mention.noAccess.label': 'Sin acceso',
    'fabric.mention.noAccess.warning': "{name} no recibir\xe1 una notificaci\xf3n porque no tiene acceso",
    'fabric.mention.unknow.user.error': 'Usuario desconocido {userId}'
};

});


//# sourceMappingURL=es.69f016fd.js.map
